import { Table } from 'antd'
import styled from 'styled-components'

const TableBaseStyle = styled.div`
  background: transparent;
  overflow: hidden;

  .ant-table {
    background-color: #f2f5f7;
    color: #333;
    &.ant-table-bordered > .ant-table-container {
      border-left: none;
    }
    .ant-table-tbody > tr.ant-table-row:hover > td, .ant-table-tbody > tr > td.ant-table-cell-row-hover {
      background: #fff;
    }
    table {
      border-radius: 0;
      border: none !important;
    }
    thead tr th {
      background-color: #f2f5f7;
      border-bottom: 1px solid #ddd;
      border-top: 1px solid #ddd;
      color: #333;
      font-size: 13.5px;
      :first-child {
        border-top-left-radius: 0 !important;
        border-left: 1px solid #ddd;
      }

      :last-child {
        border-top-right-radius: 0 !important;
      }

      ::before {
        display: none;
      }
    }
    .ant-table-tbody > tr.ant-table-row-selected > td {
      background: #f2f5f7 !important;
    }
    .ant-table-tbody > tr.ant-table-row-selected:hover > td {
      background: #fff !important;
    }
    th {
      font-size: 14px;
      font-weight: 700;
      text-align: center;
      padding: 8px 16px;
    }

    td {
      font-size: 14px;
      text-align: center;
      padding: 5px 16px;
      vertical-align: top;
    }

    tbody {
      tr {
        border-top: 1px solid #ddd;
        td {
        font-size: 13.5px !important;
          &:first-child {
            border-left: 1px solid #ddd;
          }
        }
        :last-child td {
          border-bottom: 1px solid #ddd;
        }

        &:first-child {
          display: none;
        }
      }
    }

    tfoot {
      td {
        border-top: 1px solid #ddd;
      }
    }

    .arrow-up-right-icon {
      color: #483c75 !important;
      flex-shrink: 0;
      cursor: pointer;
    }
  }

  .ant-pagination {
    .ant-pagination-item,
    button {
      border: none;
    }

    .ant-pagination-item {
      a {
        color: #a5a5a5;
      }

      &.ant-pagination-item-active a {
        color: #100f0e;
      }
    }
  }
`

const TableBase = ({ className = '', ...props }) => {
  return (
    <TableBaseStyle className={className} {...props}>
      <Table bordered {...props} />
    </TableBaseStyle>
  )
}

export default TableBase
